export const service = {
    SERVICEID:'service_3j95hjh',
    TEMPLATEID:'template_k974vwk',
    PUBLICKEY:'pKUL_9yOnRc8hc3le'
}